export enum Breakpoint {
    "xs" = "xs",
    "sm" = "sm",
    "md" = "md",
    "lg" = "lg",
    "xl" = "xl"
}

export enum BreakpointMinSizes {
    "xs" = "xs",
    "sm" = "sm",
    "md" = "md",
    "lg" = "lg",
    "xl" = "xl"
}

export enum BreakpointMaxSizes {
    "xxs" = "xxs",
    "xs" = "xs",
    "sm" = "sm",
    "md" = "md",
    "lg" = "lg"
}

export enum DeviceType {
    MOBILE = "MOBILE",
    DESKTOP = "DESKTOP"
}
